export default __webpack_public_path__ + "static/media/shipyard.05942d2c.svg";